import VueRouter from 'vue-router';

import { getSettingRoutes } from './settings-routes';
import { APP_MAIN_LANDING_PAGE } from '@/router/router.const';
export function addRequiredAuth(route, value) {
	if (route.meta) {
		route.meta.requiresAuth = value;
	} else {
		route.meta = { requiresAuth: value };
	}
	return route;
}
export const isRouteOrChildOfRoute = (currentRoute, routeName) =>
	currentRoute.name === routeName || currentRoute.matched.some((r) => routeName === r.name);

export const isMainAppLayoutChild = (route) => isRouteOrChildOfRoute(route, APP_MAIN_LANDING_PAGE);

export const getSettingsRouter = () =>
	new VueRouter({
		mode: 'abstract',
		routes: getSettingRoutes().map((x) => addRequiredAuth(x, true)),
	});
